import { Box, Drawer, Grid, IconButton, Menu } from "@mui/material";

interface Props {
  openSettingsMenuOnly?: boolean;
  handleClose: () => void;
  open: boolean;
  children?: React.ReactNode;
  anchorEl?: HTMLElement | null;
}

const LeftDrawerWrapper = ({
  anchorEl,
  openSettingsMenuOnly,
  handleClose,
  open,
  children,
}: Props) => {
  if (openSettingsMenuOnly) {
    return (
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {children}
      </Menu>
    );
  } else {
    return (
      <Drawer anchor={"left"} open={open} onClose={handleClose}>
        <Grid container justifyContent="flex-end" onClick={handleClose}>
          <IconButton sx={{ fontSize: 14 }}>
            <Box component="i" className="fa-regular fa-xmark" />
          </IconButton>
        </Grid>
        {children}
      </Drawer>
    );
  }
};

export default LeftDrawerWrapper;
